module.exports = __webpack_public_path__ + "static/img/homePenaltyGoal.73393ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/homePenaltyGoal.png
// module id = H6EI
// module chunks = 94